import React, { useEffect } from 'react';
import { Modal } from '@skf/bt-wind-rail-commonlibrary';
import * as style from './FullscreenModal.module.scss';

interface IFullscreenModalProps {
  className?: string;
  onClose: () => void;
}

export const FullscreenModal: React.FunctionComponent<IFullscreenModalProps> = ({
  onClose,
  className,
  children
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    window.scrollTo(0, 0);
    return () => {
      document.body.style.overflow = 'inherit';
    };
  });
  return (
    <Modal
      visible={true}
      className={className}
      backgroundClassName={style.backgroundModal}
      onClose={onClose}
      triangle={false}
      fullscreen={true}
    >
      {children}
    </Modal>
  );
};
